import { Typography, Box } from "@mui/material";

export default function SectionTitle({ title, subtitle }) {
  return (
    <Box sx={{ mb: 6 }}>
      <Typography
        variant="h2"
        align="center"
        gutterBottom
        sx={{ color: "#fff" }}
      >
        {title}
      </Typography>
      <Typography variant="h5" align="center" sx={{ color: "grey.500" }}>
        {subtitle}
      </Typography>
    </Box>
  );
}
